module.exports = __webpack_public_path__ + "static/img/copy.be0974c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/mitu/order/pop/copy.png
// module id = FVld
// module chunks = 1